/*                                     */
import type { ExtendedPromise, NexusSignal } from "@otto-ec/global-resources/nexus";
import { components, type OttoComponents } from "../../../common/component.js";
import type { SheetGlobalEvents } from "./event/event.global.js";
import type { ActivationOptions, SheetCreateOptions, SheetCreateProps } from "./apis/utils.js";
import type { OcSheetV1ActivationAction } from "./event/event.activation.js";
import type { ActivationReason } from "./stack/stack.utils.js";

declare global {
  interface OttoComponentApi {
    /**
 *
 *
 */
    sheetV1: SheetAsync;
  }
}

export interface OcSheetV1CurrentState {
  instance: HTMLOcSheetV1Element | null;
  id: string | null;
  isActive: boolean;
  action: OcSheetV1ActivationAction | null;
  reason: ActivationReason | null;
}

/**
 *
 */
export interface SheetAsync {
  /**
 *
 *
 *
 *
 *
 *
 *
 */
  current: NexusSignal<OcSheetV1CurrentState>;

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
  open(sheetID: string, options?: ActivationOptions): ExtendedPromise<boolean>;

  /**
 *
 *
 *
 *
 *
 *
 */
  close(options?: ActivationOptions): ExtendedPromise<boolean>;

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
  back(options?: ActivationOptions): ExtendedPromise<boolean>;

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
  create(
    props?: SheetCreateProps,
    options?: SheetCreateOptions,
  ): ExtendedPromise<HTMLOcSheetV1Element>;

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
  events: SheetGlobalEvents;

  /*              */
  getOpenSheet: () => ExtendedPromise<HTMLOcSheetV1Element | null>;
  /*              */
  getContent: () => ExtendedPromise<HTMLElement | null>;
  /*              */
  getHeader: () => ExtendedPromise<HTMLElement | null>;
  /*              */
  getActions: () => ExtendedPromise<HTMLElement | null>;
}

/**
 *
 */
export type SheetV1 = OttoComponents["sheetV1"];

/*                                                  */
export const sheet: SheetV1 = components.sheetV1;

/*                                                           */
export const current: SheetV1["current"] = sheet.current;

/*                                                */
export const open: SheetV1["open"] = sheet.open;

/*                                                 */
export const close: SheetV1["close"] = sheet.close;

/*                                                */
export const back: SheetV1["back"] = sheet.back;

/*                                                  */
export const create: SheetV1["create"] = sheet.create;

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const events: SheetV1["events"] = sheet.events;

/*                                                                    */
export const getOpenSheet: SheetV1["getOpenSheet"] = sheet.getOpenSheet;
/*                                                                 */
export const getHeader: SheetV1["getHeader"] = sheet.getHeader;
/*                                                                  */
export const getContent: SheetV1["getContent"] = sheet.getContent;
/*                                                                  */
export const getActions: SheetV1["getActions"] = sheet.getActions;
